module.exports = __webpack_public_path__ + "static/media/gt.fa32f83b.jpg";